const invertedMessages = {
  Active: 'Auth.InfoState.Active',
  Inactive: 'Auth.InfoState.Inactive',
  'Test Mode': 'Auth.InfoState.TestMode',
};

export default invertedMessages;
